import React from 'react'
import { ReaderContent } from './reader-content.component'
import { ReaderContextProvider } from './context/reader-context'

import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import LuxonUtils from '@date-io/luxon'

function ReaderMain() {
  return (
    <MuiPickersUtilsProvider utils={LuxonUtils}>
      <ReaderContextProvider>
        <ReaderContent />
      </ReaderContextProvider>
    </MuiPickersUtilsProvider>
  )
}

ReaderMain.propTypes = {}

export default ReaderMain
